<template>
<md-list-item v-if="user.active_pay">
    <md-subheader class="ql-invite-header">Invite Collaborators</md-subheader>
    <md-list-expand class="ql-invite-form">
        <md-layout md-flex="90">
            <md-input-container>
                <label>Find Existing User</label>
                <md-autocomplete v-model="autoCompleteInvitee"
                    :fetch="filter"
                    print-attribute="username"
                    :min-chars="0"
                    :max-height="6"
                    :max-res="0"
                    :debounce="500"
                    @selected="inviteCallback"
                    width="100%">
                </md-autocomplete>
            </md-input-container>
            <form nvalidate @submit.stop.prevent="inviteNew" v-show="!inviting">
                <md-input-container>
                    <label>Email</label>
                    <md-input type="email" required v-model="newInvitee.email"></md-input>
                </md-input-container>
                <md-input-container>
                    <label>Name</label>
                    <md-input type="text" required v-model="newInvitee.name"></md-input>
                </md-input-container>
                <md-input-container>
                    <label>Role</label>
                    <md-input type="text" required v-model="newInvitee.role"></md-input>
                </md-input-container>

                <md-button type="submit" class="md-raised"><md-icon>person_add</md-icon>&nbsp;Send Invite</md-button>
                <md-button class="md-raised" @click="resetInvitee">Clear</md-button>
            </form>
            <md-spinner md-indeterminate v-show="inviting && !emailSent"></md-spinner>
            <md-icon id="done-icon" v-show="inviting && emailSent">done</md-icon>
        </md-layout>
    </md-list-expand>
</md-list-item>
<md-list-item v-else>
    <md-subheader class="ql-invite-header">Invite Collaborators (disabled)</md-subheader>
</md-list-item>
</template>

<script>
import { mapGetters } from 'vuex';

const SENDMAIL_URL = 'https://us-central1-qlist-70c1e.cloudfunctions.net/sendMailgunEmail';
// const SENDMAIL_URL = 'https://us-central1-sorjak-151720.cloudfunctions.net/sendMailgunEmail';

const CollaboratorsInvite = {
    name: 'CollaboratorsInvite',
    props: ['project'],
    data: function() {
        return {
            newInvitee: {email: '', name: '', role: ''},
            // existingInvitee: null,
            autoCompleteInvitee: '',
            inviting: false,
            emailSent: false
        };
    },
    computed: {
        ...mapGetters([
            'users',
            'user'
        ])
    },
    methods: {
        resetInvitee: function() {
            this.newInvitee = {email: '', name: '', role: ''};
            this.autoCompleteInvitee = '';
        },
        filter: function({q}) {
            return new Promise((resolve) => {
                const arr = [];

                for (let i = 0; i < this.users.length; i++) {
                    if (this.users[i].username.indexOf(q) !== -1) {
                        arr.push(this.users[i]);
                    }

                    if (arr.length > 5) {
                        break;
                    }
                }

                resolve(arr);
            });
        },
        inviteCallback: function(item) {
            this.newInvitee = {
                email: item.email,
                name: item.username
            };
        },
        inviteNew: function() {
            this.$emit('addCollaborator', this.newInvitee);
            this.inviting = true;

            const host = document.URL.split('/')[2] || 'app.thecuelist.com';
            const inviteLink = `https://${host}/#/invite/${this.project.id}`;

            const emailBody = `<p>Hi ${this.newInvitee.name}</p>
                <p>You’ve been invited by <strong>${this.user.username}</strong> to collaborate on the Cuelist project <strong>${this.project.title}</strong>.</p>
                <p>Cuelist is web-based software designed to help you and your collaborators create, edit and share cues and notes directly on a PDF script in real-time. Your scripts will be constantly up-to-date and permanently archived on our secure servers.</p>
                <p>If you are a current user of Cuelist, click <a href="${inviteLink}">here</a> to accept your invite to this project<br/>
                    If you are new to Cuelist, click <a href="https://thecuelist.com">here</a> to learn more and sign up to try Cuelist today for FREE.</p>
                <p>If you have any questions, you can reach out to me personally at <a href="mailto:joshepstein@thecuelist.com">joshepstein@thecuelist.com</a>.</p>
                <p>Thanks for using Cuelist!</p>
                <p><strong>Josh Epstein</strong><br/>Founder and creator, Cuelist</p>`;

            const postData = {
                email: this.newInvitee.email,
                subject: `Invitation to collaborate on ${this.project.title} via Cuelist`,
                content: emailBody
            };

            this.$http.post(SENDMAIL_URL, postData).then((response) => {
                console.log(response);
                setTimeout(() => {
                    this.emailSent = true;
                    setTimeout(() => {
                        this.emailSent = false;
                        this.inviting = false;
                        this.resetInvitee();
                    }, 1000);
                }, 2000);
            });
        }
    }
};
export default CollaboratorsInvite;

</script>

<style lang="scss">
.ql-invite-header {
    padding-left: 0px;
}

.ql-invite-form {
    width: 100%;
    text-align: right;
    padding-left: 10px;
}
.invite-link {
    margin-top: 10px;
    h2 {
        width: 100%;
    }
}

#done-icon {
    margin-left: 0;
    color: green;
}
</style>


// WEBPACK FOOTER //
// invite.vue?249c5ed1